"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SvgIcon = require("../internal/SvgIcon");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconKeyboardArrowDown = function IconKeyboardArrowDown(_ref) {
  var className = _ref.className,
      isActive = _ref.isActive,
      htmlId = _ref.htmlId,
      other = _objectWithoutProperties(_ref, ["className", "isActive", "htmlId"]);

  return _react2.default.createElement(
    _SvgIcon2.default,
    Object.assign({
      id: htmlId,
      className: "svgicon " + (className ? className + " " : "") + (isActive === true ? "svgicon--active " : "") + "icon-keyboard-arrow-down"
    }, other),
    _react2.default.createElement("polygon", { points: "12 15.4 6.6 10 8 8.6 12 12.6 16 8.6 17.4 10" })
  );
};
IconKeyboardArrowDown.propTypes = {
  /** Additional classes to add to &lt;IconKeyboardArrowDown/&gt; */
  className: _propTypes2.default.string,
  /** Globally unique, descriptive ID. Used for automated testing. */
  htmlId: _propTypes2.default.string,
  /** Set icon to active state when true. See [Icon Buttons](/components/button#ButtonIcon) for other clickable icons. */
  isActive: _propTypes2.default.bool
};
exports.default = IconKeyboardArrowDown;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cx/ui/Icons/IconKeyboardArrowDown.js
// module id = 585
// module chunks = 0